import React from 'react';

function SocialLinks() {
    return (
        <div>
            <div className="flex flex-wrap space-x-3 text-xl">
                <a
                    href="https://www.facebook.com/m.rakibul.islam.raju/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fab fa-facebook hover:text-red-600" />
                </a>
                <a
                    href="https://www.linkedin.com/in/rakibul-islam-raju/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fab fa-linkedin hover:text-red-600" />
                </a>
                <a
                    href="https://github.com/rakibul-islam-raju"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fab fa-github hover:text-red-600" />
                </a>
                <a href="skype:rakibul.islam203?chat" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-skype hover:text-red-600" />
                </a>
            </div>
        </div>
    );
}

export default SocialLinks;
